<template>
  <div>
    <div class="font-weight-bold black--text" style="font-size: 18px">
      <v-row class="ma-0" align="center">
        <span :style="items.length == 0 ? 'visibility: hidden' : ''">
          Top Profitable Trades
        </span>
        <v-spacer />
        <v-btn
          @click="addTrade()"
          color="#2d8cff"
          class="mx-auto add-trade-button white--text d-none d-sm-flex"
        >
          <v-icon color="#fff">mdi-plus</v-icon> Add new trade
        </v-btn>
      </v-row>
    </div>
    <v-col class="pa-0" v-if="loading && page === 1">
      <v-skeleton-loader
        v-for="item in 3"
        :key="item"
        class="mt-4"
        type="list-item-avatar, divider, list-item-three-line"
      />
    </v-col>
    <v-col v-else>
      <ProfitableTradeCard
        class="mt-4"
        v-for="(item, index) in items"
        :key="index"
        :trade_data="item"
        :is_followed="item.is_following_user"
      />
    </v-col>
    <v-col class="mt-4" v-if="isNextPage">
      <v-btn
        color="white"
        block
        :loading="loading"
        @click="nextPage"
        class="primary--text font-weight-bold text-capitalize body-1"
      >
        Show More
      </v-btn>
    </v-col>
  </div>
</template>

<script>
import ProfitableTradeCard from "@/components/Trending/ProfitableTrade/ProfitableTradeCard.vue";

export default {
  components: { ProfitableTradeCard },
  data: () => ({
    trendingTradesLoading: false,
  }),
  computed: {
    page: {
      get() {
        return this.$store.state.trendingTrades.page;
      },
      set(value) {
        this.$store.commit("trendingTrades/setPage", value);
      },
    },
    isNextPage: {
      get() {
        return this.$store.state.trendingTrades.isNextPage;
      },
      set(value) {
        this.$store.commit("trendingTrades/setIsNextPage", value);
      },
    },
    items() {
      return this.$store.state.trendingTrades.allItems;
    },
    loading() {
      return this.$store.state.trendingTrades.loading;
    },
  },
  watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    addTrade() {
      // console.log("trending event fire");
      this.$logEvent("add_trade_trending_page");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_trade_trending_page");
      }
      this.$emit("add-trade");
    },
    getData() {
      this.$store.dispatch("trendingTrades/getProfitableTrades", {});
    },
    nextPage() {
      if (this.isNextPage !== null) this.page++;
      this.$logEvent("profitable_trades_show_more");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_profitable_trades_show_more");
      }
    },
  },
  mounted() {
    this.$store.dispatch("trendingTrades/resetPage");
    this.getData();
  },
};
</script>

<style></style>
